import common from "./common.json";
import sys from "./sys.json";
import dict from "./dict.json";

export default {
	...common,
	...sys,
	...dict,
};
